<template>
  <div class="vx-grid-asset" :style="`--width: ${width}; --height: ${height}`">
    <div
      class="vx-grid-asset-container d-block h-100"
      :class="{ 'vx-grid-bottom-bar': showBottomBar }"
    >
      <a v-if="link" :href="link" @click="$emit('click', $event)">
        <slot></slot>
      </a>
      <div v-else @click="$emit('click', $event)">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    link: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    showBottomBar: {
      type: Boolean,
      default: false,
      required: false
    }
  }
};
</script>

<style lang="scss" scoped>
.vx-grid-asset {
  margin-right: 0.75em;
  margin-bottom: 0.75em;
  flex-grow: calc(var(--ratio) * 100);
  --ratio: calc(var(--width) / var(--height));
  --row-height: 12rem;
  flex-basis: calc(var(--ratio) * var(--row-height));
  a,
  a:hover {
    color: gray;
  }
}

.vx-grid-asset-container {
  position: relative;
  height: 100%;
  width: 100%;
}

.vx-grid-bottom-bar {
  margin-bottom: 50px;
}
</style>
